<dx-popup *ngIf="registrationResultModel"
  [visible]="showModal"
  [width]="510"
  [height]="'auto'"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  [showCloseButton]="false"
  (onHidden)="close()"
>
    <ng-container *ngIf="!registrationResultModel.userAlreadyExists; else userAlreadyExistsTemplate">
        <div class="text-center">
            <h2 class="title">{{ 'REGISTRATION.THANK-YOU-FOR-REGISTRATION' | translate }}</h2>
            <p class="text-message">{{ 'REGISTRATION.SENT-LOGIN-DETAILS' | translate }}</p>
            <p class="text-message">{{ 'REGISTRATION.CLOSE-THIS-WINDOW' | translate }}</p>
            <dx-button
                class="close-button"
                [text]="'COMMON.CLOSE' | translate"
                color="primary"
                (onClick)="close()"
            ></dx-button>
        </div>
    </ng-container>
    <ng-template #userAlreadyExistsTemplate>
        <div class="text-center">
            <h2 class="title">{{ 'REGISTRATION.KNOW-EACH-OTHER' | translate }}</h2>
            <p class="text-message">{{ 'REGISTRATION.EMAIL-ALREADY-IN-SYSTEM' | translate }}</p>
            <p class="text-message" [innerHTML]="loginTextHtml"></p>
            <dx-button
                class="close-button"
                [text]="'COMMON.CLOSE' | translate"
                color="primary"
                (onClick)="close()"
            ></dx-button>
        </div>
    </ng-template>
</dx-popup>